import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/banners/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function create(values) {
  return request({
    url:    '/banners/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/banners/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/banners/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/banners/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const BannersService = {
  get, create, update, remove, find
}

export default BannersService;
